module.exports = __webpack_public_path__ + "static/media/download.404f6c17.svg";